<template>
  <button class="btn" :class="{'btn-lg': large}" :disabled="disabled">
    <span
      v-if="disabled" class="spinner-border"
      :class="large ? 'spinner-border-fix' : 'spinner-border-sm'"
    />
    <template v-else>
      <slot />
    </template>
  </button>
</template>

<script>
export default {
  props: {
    loading: { type: Boolean, required: true },
    large: { type: Boolean, default: false },
  },
  data: () => ({ disabled: false }),
  watch: {
    loading(value) {
      if (value) this.disabled = true;
      else setTimeout(() => { this.disabled = false; }, 100);
    },
  },
};
</script>

<style scoped>
  .spinner-border-fix { margin-bottom: -8px; }
</style>
